import React from "react";

const initialState = {
    updatedRejectedReason: null
};

export default class ReceivingParticipantsTableRow extends React.Component {
    constructor(props) {
        super(props);

        this.state = initialState;
    }
    
    onToggleReject = (event, participant) => {
        const checked = event.target.checked;
        const id = participant.externalListMemberId.toString();
    
        if (checked) {
          this.props.updateRejectedParticipants([...this.props.rejectedParticipants, {key: id}]);
        } else {
          this.props.updateRejectedParticipants(this.props.rejectedParticipants.filter(p => p.key.toString() !== id));
          this.setState({ updatedRejectedReason: null });
        }
    }
    
    onChangeRejectedReason = e => {
        this.setState({
            updatedRejectedReason: e.target.value
        });
    }

    updateRejectedReason = (participant, reason) => {
        const id = participant.externalListMemberId.toString();

        this.props.updateRejectedParticipants(
            [...this.props.rejectedParticipants.filter(p => p.key.toString() !== id), 
            {key: id, value: reason}]);

        this.setState({ updatedRejectedReason: null });
    }
      
    render() {
        const participant = this.props.participant;
        const id = participant.externalListMemberId.toString();
        const rejectedParticipant = this.props.rejectedParticipants.find(member => member.key.toString() === id);

        const isRejected = rejectedParticipant ? true : false;
        const rejectedReason = isRejected === true ?  rejectedParticipant.value : "";
        
        return (
        <tr className="table-row" key={participant.externalListMemberId}>
            <td>
            <div className="custom-check-container">
                <input
                    type="checkbox"
                    id={`reject-${participant.externalListMemberId}`}
                    onChange={e => this.onToggleReject(e, participant)}
                    className="custom-check"
                    checked={isRejected}
                />
                <label
                    htmlFor={`reject-${participant.externalListMemberId}`}
                    className="secondary-text"
                />
            </div> 
            </td>
            <td data-label="Name">
                <p>{participant.name}</p>
            </td>
            <td data-label="Position">
                <p>{participant.orgEmployment}</p>
            </td>
            <td data-label="Rejected Reason">
                <input type="text" 
                    value={this.state.updatedRejectedReason !== null ? this.state.updatedRejectedReason : (rejectedReason || '')}
                    disabled={!isRejected}
                    onChange={this.onChangeRejectedReason} 
                    onKeyDown={e => { if (e.key === 'Enter' ) this.updateRejectedReason(participant, e.target.value) }}
                    onBlur={ e => this.updateRejectedReason(participant, e.target.value) }/>
            </td>
        </tr>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignDetails/VerifyCampaignListWizard/ReceivingParticipantsTableRow.jsx